import { Link } from "react-router-dom";
import { Stethoscope } from "lucide-react";

export function Logo({ to = "/", className = "", compact = false }) {
  return (
    <Link to={to} data-testid="app-logo" className={`flex items-center gap-2 ${className}`}>
      <span className="grid h-9 w-9 place-items-center rounded-xl bg-primary text-primary-foreground shadow-sm">
        <Stethoscope className="h-5 w-5" />
      </span>
      {!compact && (
        <span className="font-display text-lg font-semibold tracking-tight text-foreground">
          Role-play <span className="text-primary">Connect</span>
        </span>
      )}
    </Link>
  );
}
